import $ from "jquery";
import {gsap} from "gsap";

const $blocs = $(".multifeature-bloc")
let anim = false;
const active_class = 'feature-active';

const init_multifeature = () => {
    if($blocs.length){
        init();
    }
}

const init = ()=>{

   // Disable a accodion item for closing itself
    $.each($('.accordion-collapse'), function (index, value){
        value.addEventListener("hide.bs.collapse", (e) => on_hide_handler(e));
        value.addEventListener("hidden.bs.collapse", (e) => on_hiden_handler(e));
        value.addEventListener("show.bs.collapse", (e) => on_show_handler(e));
    })

}


const on_show_handler = (e) => {
    const $button =getTheButtonClicked(e);
    const $accordion = $button.parents('.multifeature_accordion');
    $accordion.addClass("disabled");
    $button.attr('data-bs-toggle','disabled');

    console.log($button);
    //index cliqued
    const index = $button.data('featureindex');
    const $ul_image = $button.parents('.multifeatures-wrapper').children('.col-features-images').children('.features-images-wrapper');
    const $li_image_active = $ul_image.find('li.features-image-wrapper.feature-active');
    const $li_image_to_active = $ul_image.find('li.features-image-wrapper').eq(index - 1);
    anim = gsap.timeline({})
        .to($li_image_active, {autoAlpha:0,y:-20, duration:.2, ease:"power1.out", onComplete:() => {
                $li_image_active.removeClass(active_class)
                $li_image_to_active.addClass(active_class)
            }})
        .fromTo($li_image_to_active, {autoAlpha:0,y:+20}, {autoAlpha:1,y:0, duration:.2, delay:.1, ease:"power1.out"});
}
const on_hide_handler = (e) => {
    const $button =getTheButtonClicked(e);
    $button.attr('data-bs-toggle','collapse');
}
const on_hiden_handler = (e) => {
    const $button =getTheButtonClicked(e);
    const $accordion = $button.parents('.multifeature_accordion');
    $accordion.removeClass("disabled");
}

const getTheButtonClicked = (e) => {
    const $target = $(e.currentTarget);
    return $target.prev().children();
}


export {init_multifeature}